// import React from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import { BsFiletypeXls } from "react-icons/bs";
// import { AddActionsButton } from "./AddElementsButton";

// const ExcelFormat = ({ data, fileName, columns, buttonText = "Export to Excel" }) => {
//     const exportToExcel = () => {
//         if (!data || data.length === 0) {
//             alert("Nuk ka të dhëna për eksport!");
//             return;
//         }

//         // Filtrimi i kolonave të përcaktuara nga përdoruesi
//         const filteredData = data.map(item =>
//             columns.reduce((obj, col) => {
//                 obj[col] = item[col];
//                 return obj;
//             }, {})
//         );

//         const worksheet = XLSX.utils.json_to_sheet(filteredData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//         const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//         const excelFile = new Blob([excelBuffer], {
//             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         });

//         saveAs(excelFile, `${fileName}.xlsx`);
//     };

//     return (
//         <>
//             <AddActionsButton
//                 text={buttonText}
//                 onClick={exportToExcel}
//                 icon={<BsFiletypeXls />}
//                 className="button-15"
//             />
//         </>

//     )
//     // <button onClick={exportToExcel}>{buttonText}</button>;
// };

// export default ExcelFormat;


import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BsFiletypeXls } from "react-icons/bs";
import { AddActionsButton } from "../AddElementsButton";
import { updateAlert } from "../Alerts";

const ExcelFormat = ({ data, fileName, columns, columnMappings, buttonText = "Export to Excel" }) => {
    const exportToExcel = () => {
        if (!data || data.length === 0) {
            updateAlert("Nuk ka të dhëna për eksport!");
            return;
        }

        // Filtrimi dhe ndryshimi i emrave të kolonave sipas mappings
        const filteredData = data.map(item =>
            columns.reduce((obj, col) => {
                obj[columnMappings[col] || col] = item[col]; // Nëse ka përkthim, e përdorim
                return obj;
            }, {})
        );

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(excelFile, `${fileName}.xlsx`);
    };

    return (
        <>
            <AddActionsButton
                text={buttonText}
                onClick={exportToExcel}
                icon={<BsFiletypeXls />}
                className="button-15"
            />
        </>
    );
};

export default ExcelFormat;
